module.exports = __webpack_public_path__ + "static/CarouselNew-b49ff0225ab1a87eba4e53f05c6e0af1.mp4";